import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type Patient from "./patient";

export const proIrcFur = "nephro-mrc-pro-irc";

//---- Automatically generated, don't update this part ----

export default class ProIrcStatusUpdatedJournalEvent extends JournalEvent {
  static override type = "pro-irc-status-updated-journal-event";

  /**
   * The date of the inclusion in the pro irc program
   */
  @attr("date") declare proIrcStartDate: Date;

  /**
   * Is the patient included in the program
   */
  @attr("boolean", {
    allowNull: true
  })
  declare included: boolean;

  static override validations(intl: IntlService) {
    return {
      proIrcStartDate: validatePresence({
        presence: true,
        description: intl.t(
          "validations.pro-irc-status-updated-journal-event.pro-irc-start-date"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.pro-irc-status-updated-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "proIrcStatusUpdatedJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "pro-irc-status-updated-journal-event": ProIrcStatusUpdatedJournalEvent;
  }
}
